module.exports = __webpack_public_path__ + "static/img/banner4.9f03678.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/banner4.jpg
// module id = pWJ+
// module chunks = 1